import moment from 'moment'
import {
  DATE_FILTER_FORMAT,
  RequiredDateFilterDefault,
} from '@components/integration-filters/components'
import { DataOption } from '../../components'

export const GoogleCM360DataOptions = [
  {
    type: 'campaigns',
    label: 'Campaigns',
  },
  {
    type: 'placements',
    label: 'Placements',
  },
  {
    type: 'ads',
    label: 'Ads',
  },
  {
    type: 'creatives',
    label: 'Creatives',
  },
  {
    type: 'creative_assets',
    label: 'Creative Assets',
  },
  {
    type: 'all',
    label: 'All (Legacy)',
  },
] as const satisfies DataOption[]

export const GOOGLE_CM360_DATA_TYPE_KEY = 'cm360_data_type'

const oneYearAgo = moment().subtract(1, 'years').format(DATE_FILTER_FORMAT)

export const GCM_REQUIRED_FILTER_DEFAULTS = [
  {
    key: 'campaign_start_date_filter',
    operator: '>',
    value: oneYearAgo,
    display_name: oneYearAgo,
  },
  {
    key: 'ad_start_time_filter',
    operator: '>',
    value: oneYearAgo,
    display_name: oneYearAgo,
  },
  {
    key: 'placement_start_date_filter',
    operator: '>',
    value: oneYearAgo,
    display_name: oneYearAgo,
  },
] as const satisfies RequiredDateFilterDefault[]
